import React, { useContext, useEffect, useRef, useState } from "react";
import BubbleImportFunction from "../../temple/templegridroom/BubblesJSONcommandPanel.json/BubbleImportFunction";
import BubbleDisplayImg from "../../temple/templegridroom/Flex/TgridEditorForm/bubblesDisplay/BubbleDisplayImg";
import { AuthContext } from "../../context/App-Context";
import axios from "axios";
import { createPortal } from "react-dom";
import OcancerzStarszPostItems from "../OcancerzStarsz/OcancerzStarszPostItems";

const BUBBLE_KIT_MAP = {
  HUM1: "human",
  HOM2: "home",
  GEO3: "geo",
  FIR4: "fireworks",
  P3D5: "portrait3d",
  TRP6: "portraittrap",
  AFR7: "portraitafrica",
  AFZ8: "portraitafricazone",
  AFW9: "africawesttrap",
  AFS0: "africasouthtrap",
  LTK1: "letterkit",
  LHK2: "letterhebrewkit",
  LHT3: "letterhebrewtextkit",
  LGT4: "lettergreektextkit",
  WDK1: "wordkindkit",
  WDH2: "wordhidekit",
  WDA3: "wordanimalkit",
  WKC4: "wordkindcontourkit",
  WNC5: "wordnocontourkit",
  WAC6: "wordanimalcontourkit",
  CTK7: "customtextcontourkit",
  ROD1: "road",
  CAR1: "car",
  CUB1: "carcube",
  CBT2: "carcubetilt",
  CBS3: "carcubesegment",
  CBF4: "carcubefused",
  CBA5: "carcubealign",
  AUR1: "aura",
  RDO1: "radarone",
  RDT2: "radartwo",
  GUA1: "guardian",
  GHO1: "ghost",
  STR1: "starlight",
  HPR1: "humanpresence",
  RBW1: "starspirit",
  SPW1: "cosm",
};

const STAR_TRAIL_KITS = ["starspirit"];

const OcancerzStarFormItems = (props) => {
  const [data, setData] = useState(null);
  const [dataForBubbles, setDataForBubbles] = useState(null);
  const [StarFormsImages, setpostPhotos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [mergedStarImages, setMergedStarImages] = useState([]);
  const [showMergedPosts, setShowMergedPosts] = useState(false);

  const [previewIndex, setPreviewIndex] = useState(null);
  const modalScrollRef = useRef(null);

  const [selectedPreviewKit, setSelectedPreviewKit] = useState(null);

  const rawBubblesArray = dataForBubbles
    ? Array.isArray(dataForBubbles)
      ? dataForBubbles
      : [dataForBubbles]
    : [];
  const allBubbles = rawBubblesArray.filter(
    (b) => b && Object.keys(b).length > 0
  );

  const starTrailBubbles = allBubbles.filter((b) => {
    const kitCode = b?.templeGridpostBubblesData?.activeKit || b?.activeKit;
    return (
      b?.templeGridpostBubblesData?.typeofPost === "starTrail" ||
      b?.typeofPost === "starTrail" ||
      STAR_TRAIL_KITS.includes(kitCode)
    );
  });

  const standardBubbles = allBubbles.filter((b) => {
    const kitCode = b?.templeGridpostBubblesData?.activeKit || b?.activeKit;
    return (
      b?.templeGridpostBubblesData?.typeofPost !== "starTrail" &&
      b?.typeofPost !== "starTrail" &&
      !STAR_TRAIL_KITS.includes(kitCode)
    );
  });

  // 🌟 FIX: We default to "none" so the effect ONLY shows when you click the pill!
  const activePreviewKit =
    selectedPreviewKit !== null ? selectedPreviewKit : "none";

  useEffect(() => {
    if (previewIndex !== null && modalScrollRef.current) {
      setTimeout(() => {
        if (modalScrollRef.current) {
          modalScrollRef.current.scrollLeft =
            modalScrollRef.current.clientWidth * previewIndex;
        }
      }, 10);
    }
  }, [previewIndex !== null]);

  const formatShortTime = (timeStr) => {
    if (!timeStr) return "";
    return timeStr
      .replace(/, \d{4}/, "")
      .replace(/\s*[a-z]{3}$/i, "")
      .trim();
  };

  const auth = useContext(AuthContext);

  const handleBubblesClick = () => {
    if (props.onEditPost && data) {
      props.onEditPost({
        uid: props.postFunction,
        postText: data.ocancerzStarFormText,
        postDate: data.postDate,
        postImages: StarFormsImages || [],
        starsinConstellation: data.starsinConstellation,
        postType: "constellation",
      });
    }
  };

  const isFetched = useRef(false);

  useEffect(() => {
    if (isFetched.current && props.refreshFeedBubbles === undefined) return;

    let isMounted = true;
    setLoading(true);

    const fetchAllData = async () => {
      try {
        const [imagesResponse, formResponse] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getImagesOcancerzStarForm?username=${auth.loginVar}&uid=${props.postFunction}`
          ),
          axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getOcancerzStarForm/${auth.loginVar}/${props.postFunction}`
          ),
        ]);

        if (!isMounted) return;

        setpostPhotos(imagesResponse.data.data.functionGo);
        let formGo = formResponse.data.functionGO;

        if (formGo && typeof formGo.starsinConstellation === "string") {
          try {
            formGo.starsinConstellation = JSON.parse(
              formGo.starsinConstellation
            );
          } catch (e) {
            formGo.starsinConstellation = [];
          }
        }

        setData(formGo);

        if (formGo.starsinConstellation.length > 0) {
          const validStarIds = formGo.starsinConstellation.filter(
            (id) => id && typeof id === "string" && id.trim() !== ""
          );
          if (validStarIds.length > 0) {
            const promises = validStarIds.map((id) =>
              axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getImagesOcancerzStarPost?username=${auth.loginVar}&uid=${id}`
              )
            );
            const imageResponses = await Promise.all(promises);
            let extractedImages = [];
            imageResponses.forEach((res) => {
              const imgs = res.data?.data?.functionGo;
              if (imgs && imgs.length > 0) extractedImages.push(imgs[0]);
            });
            if (isMounted) setMergedStarImages(extractedImages);
          }
        }

        let bubbleIdToFetch = null;
        if (formGo && formGo.postBubbles) {
          bubbleIdToFetch = Array.isArray(formGo.postBubbles)
            ? formGo.postBubbles[0]
            : formGo.postBubbles;
        }

        if (
          bubbleIdToFetch &&
          typeof bubbleIdToFetch === "string" &&
          bubbleIdToFetch.trim() !== ""
        ) {
          const bubblesResponse = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/ocancerz-metavz/getOcancerzStarFormBubbles/${bubbleIdToFetch}`
          );
          if (isMounted)
            setDataForBubbles(bubblesResponse.data.data.functionGo);
        } else {
          if (isMounted) setDataForBubbles(null);
        }

        isFetched.current = true;
      } catch (err) {
        if (isMounted) setError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchAllData();
    return () => {
      isMounted = false;
    };
  }, [auth.loginVar, props.postFunction, props.refreshFeedBubbles]);

  return (
    <div>
      <style>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>

      {/* FULLSCREEN MODAL PREVIEW CAROUSEL */}
      {previewIndex !== null &&
        createPortal(
          <div
            className="photo-preview-modal"
            onClick={() => setPreviewIndex(null)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              zIndex: 99999,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <button
              className="close-preview-btn"
              onClick={() => setPreviewIndex(null)}
              style={{
                position: "absolute",
                top: "20px",
                right: "30px",
                background: "none",
                color: "#00008b",
                border: "none",
                fontSize: "50px",
                cursor: "pointer",
                zIndex: 100000,
                fontWeight: "100",
                lineHeight: "0.5",
              }}
            >
              ×
            </button>

            {/* 🌟 FLOATING BUBBLE TOGGLE MENU */}
            {standardBubbles.length > 0 && (
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: "absolute",
                  bottom: "30px",
                  right: "30px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  zIndex: 100000,
                }}
              >
                {standardBubbles
                  .filter((b) => b && Object.keys(b).length > 0)
                  .filter((bubbleItem, index, self) => {
                    const getCode = (b) =>
                      b?.templeGridpostBubblesData?.hiddenCode ||
                      b?.hiddenCode ||
                      b?.templeGridpostBubblesData?.activeKit ||
                      b?.activeKit;
                    const code = getCode(bubbleItem);
                    return index === self.findIndex((t) => getCode(t) === code);
                  })
                  .map((bubbleItem, index) => {
                    const rawCode =
                      bubbleItem?.templeGridpostBubblesData?.activeKit ||
                      bubbleItem?.activeKitCode ||
                      bubbleItem?.activeKit ||
                      bubbleItem?.hiddenCode;

                    const kitName =
                      BUBBLE_KIT_MAP[rawCode] || rawCode || "none";
                    const isCurrentlyActive = activePreviewKit === kitName;
                    const label =
                      kitName === "none" ? "NONE" : kitName.toUpperCase();

                    return (
                      <button
                        key={bubbleItem.uid || index}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedPreviewKit(
                            isCurrentlyActive ? "none" : kitName
                          );
                        }}
                        style={{
                          background: isCurrentlyActive ? "#00008b" : "#ffffff",
                          color: isCurrentlyActive ? "#ffffff" : "#00008b",
                          border: "2px solid #00008b",
                          borderRadius: "20px",
                          padding: "8px 16px",
                          fontWeight: "bold",
                          fontFamily: "monospace",
                          cursor: "pointer",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          transition: "all 0.2s ease",
                        }}
                      >
                        ⚡ {label}
                      </button>
                    );
                  })}
              </div>
            )}

            {/* THE SWIPEABLE MODAL CAROUSEL */}
            <div
              className="photo-grid hide-scrollbar"
              style={{
                display: "flex",
                flexWrap: "nowrap",
                overflowX: "auto",
                gap: "12px",
                paddingBottom: "12px",
                scrollSnapType: "x mandatory",
                WebkitOverflowScrolling: "touch",
                width: "100%",
              }}
            >
              {StarFormsImages &&
                StarFormsImages.map((photo, index) => {
                  const imgSrc =
                    photo.url ||
                    photo.img ||
                    photo.image ||
                    photo.src ||
                    photo.postImage ||
                    photo.postImages ||
                    photo.StarPostImages ||
                    photo.StarFormsImages ||
                    (typeof photo === "string" ? photo : "");

                  const imgTime =
                    photo.time ||
                    photo.timestamp ||
                    (data?.imageTimestamps
                      ? data.imageTimestamps[index]
                      : null);

                  return (
                    <div
                      key={photo.key || photo.filename || `photo-${index}`}
                      role="button"
                      tabIndex={0}
                      onClick={() => {
                        setPreviewIndex(index);
                        setSelectedPreviewKit(null);
                      }}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: "0 0 100%",
                        maxWidth: "100%",
                        scrollSnapAlign: "start",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          margin: 0,
                          width: "100%",
                          height: "auto",
                          maxHeight: "260px",
                          overflow: "hidden",
                          borderRadius: "6px",
                          background: "transparent",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "none",
                        }}
                      >
                        <BubbleDisplayImg
                          src={imgSrc}
                          activeKit={activePreviewKit}
                          showOcancer={false}
                          connectedImages={mergedStarImages.map(
                            (img) => img.url || img.src
                          )}
                        />
                      </div>

                      {imgTime && (
                        <div
                          style={{
                            marginTop: "8px",
                            textAlign: "left",
                            paddingLeft: "4px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#007bff",
                              fontWeight: "bold",
                            }}
                          >
                            {formatShortTime(imgTime)}
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>,
          document.body
        )}

      {data && (
        <div style={{ width: "100%", minWidth: 0, boxSizing: "border-box" }}>
          <article
            key={data.uid}
            className="post-card"
            style={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
              overflow: "hidden",
              background: "#fdfdfd",
              border: "1px solid #eaeaea",
              borderRadius: "8px",
              padding: "12px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="post-header"
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                flexWrap: "wrap",
                marginBottom: "8px",
              }}
            >
              <span className="avatar">👑</span>
              <span
                className="username"
                style={{ fontWeight: "bold", wordBreak: "break-all" }}
              >
                {auth.loginVar}
              </span>
              <span
                className="timestamp"
                style={{ fontSize: "0.8rem", color: "#888" }}
              >
                {data.postDate}
              </span>
            </div>

            <p
              className="post-text"
              style={{
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "pre-wrap",
                margin: "0 0 12px 0",
                fontSize: "0.9rem",
              }}
            >
              {data.ocancerzStarFormText}
            </p>

            {StarFormsImages && (
              <div style={{ width: "100%", maxWidth: "100%", minWidth: 0 }}>
                <div
                  className="photo-grid hide-scrollbar"
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    gap: "12px",
                    paddingBottom: "12px",
                    scrollSnapType: "x mandatory",
                    WebkitOverflowScrolling: "touch",
                    width: "100%",
                  }}
                >
                  {StarFormsImages.map((photo, index) => {
                    const imgSrc =
                      photo.url ||
                      photo.img ||
                      photo.image ||
                      photo.src ||
                      photo.postImage ||
                      photo.postImages ||
                      photo.StarPostImages ||
                      photo.StarFormsImages ||
                      (typeof photo === "string" ? photo : "");

                    const imgTime =
                      photo.time ||
                      photo.timestamp ||
                      (data?.imageTimestamps
                        ? data.imageTimestamps[index]
                        : null);

                    return (
                      <div
                        key={photo.key || photo.filename || `photo-${index}`}
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                          setPreviewIndex(index);
                          setSelectedPreviewKit(null);
                        }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: "0 0 100%",
                          maxWidth: "100%",
                          scrollSnapAlign: "start",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            margin: 0,
                            width: "100%",
                            height: "auto",
                            maxHeight: "260px",
                            overflow: "hidden",
                            borderRadius: "6px",
                            background: "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                          }}
                        >
                          {/* 🌟 FIX: Plain image tag in feed. We also add crossOrigin so it caches safely for the modal! */}
                          <img
                            crossOrigin="anonymous"
                            src={imgSrc}
                            alt={photo.filename || `Photo ${index + 1}`}
                            loading="lazy"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "260px",
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              display: "block",
                              transform: "none",
                              transition: "none",
                            }}
                          />
                        </div>

                        {imgTime && (
                          <div
                            style={{
                              marginTop: "8px",
                              textAlign: "left",
                              paddingLeft: "4px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                color: "#007bff",
                                fontWeight: "bold",
                              }}
                            >
                              {formatShortTime(imgTime)}
                            </span>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Stacked Merged Star Images (The Toggle Button) */}
            {data?.starsinConstellation &&
              data.starsinConstellation.length > 0 &&
              mergedStarImages.length > 0 && (
                <div
                  onClick={() => setShowMergedPosts(!showMergedPosts)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 15px 10px 15px",
                    cursor: "pointer",
                    transition: "opacity 0.2s",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.opacity = "0.7")}
                  onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
                >
                  <span
                    style={{
                      fontSize: "0.75rem",
                      color: "#888",
                      marginRight: "10px",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                    }}
                  >
                    Stars
                  </span>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {mergedStarImages.map((img, idx) => (
                      <img
                        key={idx}
                        src={img.url || img.src}
                        alt={`Merged Star ${idx}`}
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid white",
                          marginLeft: idx === 0 ? "0" : "-12px",
                          zIndex: mergedStarImages.length - idx,
                          boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                          backgroundColor: "#eee",
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}

            <div className="post-footer">
              {!props.isPreviewMode && standardBubbles.length > 0 && (
                <div
                  className="active-bubbles-display"
                  style={{
                    marginTop: "12px",
                    paddingTop: "12px",
                    borderTop: "1px solid #00008b",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                  }}
                >
                  {standardBubbles
                    .filter(
                      (bubbleItem) =>
                        bubbleItem !== null &&
                        bubbleItem !== undefined &&
                        Object.keys(bubbleItem).length > 0
                    )
                    .filter((bubbleItem, index, self) => {
                      const getCode = (b) =>
                        b?.hiddenCode ||
                        b?.templeGridpostBubblesData?.hiddenCode ||
                        b?.activeKit ||
                        b?.templeGridpostBubblesData?.activeKit;
                      const code = getCode(bubbleItem);
                      return (
                        index === self.findIndex((t) => getCode(t) === code)
                      );
                    })
                    .map((bubbleItem, index) => (
                      <div key={index}>
                        <BubbleImportFunction
                          showBubbles={
                            bubbleItem?.templeGridpostBubblesData?.activeKit ||
                            bubbleItem?.activeKit
                          }
                          showCode={
                            bubbleItem?.templeGridpostBubblesData?.hiddenCode ||
                            bubbleItem?.hiddenCode
                          }
                        />
                      </div>
                    ))}
                </div>
              )}
            </div>

            <div
              className="bubbles-area"
              onClick={handleBubblesClick}
              style={{
                cursor: "pointer",
                padding: "8px",
                background: "#f0f0f0",
                borderRadius: "6px",
                marginTop: "8px",
              }}
            >
              Bubbles <span style={{ fontSize: "1.2em" }}>+</span>
            </div>

            {/* HORIZONTAL CAROUSEL */}
            {showMergedPosts &&
              data?.starsinConstellation &&
              data.starsinConstellation.length > 0 && (
                <div
                  style={{
                    marginTop: "15px",
                    paddingTop: "15px",
                    borderTop: "2px dashed #ccc",
                  }}
                >
                  <h4
                    style={{
                      margin: "0 0 15px 0",
                      color: "#00008b",
                      textAlign: "center",
                    }}
                  >
                    Connected Stars
                  </h4>
                  <div
                    className="hide-scrollbar"
                    style={{
                      display: "flex",
                      overflowX: "auto",
                      gap: "20px",
                      paddingBottom: "15px",
                      scrollSnapType: "x mandatory",
                      WebkitOverflowScrolling: "touch",
                    }}
                  >
                    {data.starsinConstellation.map((starId, i) => (
                      <div
                        key={`${starId}-${i}`}
                        style={{
                          minWidth: "320px",
                          width: "320px",
                          flexShrink: 0,
                          border: "1px solid #e0e0e0",
                          borderRadius: "14px",
                          background: "#ffffff",
                          boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
                          overflow: "hidden",
                          scrollSnapAlign: "start",
                        }}
                      >
                        <OcancerzStarszPostItems
                          postFunction={starId}
                          onEditPost={props.onEditPost}
                          isPreviewMode={true}
                          inheritedStarTrailBubbles={starTrailBubbles}
                        />
                      </div>
                    ))}
                  </div>

                  {/* 🌟 STAR TRAIL BUBBLE BADGES */}
                  {starTrailBubbles.length > 0 && (
                    <div
                      className="star-trail-bubbles-display"
                      style={{
                        marginTop: "15px",
                        paddingTop: "15px",
                        borderTop: "1px dashed #ccc",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: "6px",
                      }}
                    >
                      {starTrailBubbles
                        .filter(
                          (bubbleItem) =>
                            bubbleItem !== null &&
                            bubbleItem !== undefined &&
                            Object.keys(bubbleItem).length > 0
                        )
                        .filter((bubbleItem, index, self) => {
                          const getCode = (b) =>
                            b?.hiddenCode ||
                            b?.templeGridpostBubblesData?.hiddenCode ||
                            b?.activeKit ||
                            b?.templeGridpostBubblesData?.activeKit;
                          const code = getCode(bubbleItem);
                          return (
                            index === self.findIndex((t) => getCode(t) === code)
                          );
                        })
                        .map((bubbleItem, index) => (
                          <div key={`startrail-${index}`}>
                            <BubbleImportFunction
                              showBubbles={
                                bubbleItem?.templeGridpostBubblesData
                                  ?.activeKit || bubbleItem?.activeKit
                              }
                              showCode={
                                bubbleItem?.templeGridpostBubblesData
                                  ?.hiddenCode || bubbleItem?.hiddenCode
                              }
                            />
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              )}
          </article>
        </div>
      )}
    </div>
  );
};

export default React.memo(OcancerzStarFormItems);
